<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">
                    Images For Approval
                </div>
            </div>
            <!--page content-->
            <div class="admin-page-content">

                <form id="benefitForm">
                    <div class="row">
                        <template v-for="(text, index) in imagesForApproval">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-20">
                                <div class="card">
                                    <div class="card-body">
                                        <!--Image Section-->
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <a class="image-zoom" :href="text.image" rel="prettyPhoto[gallery]" :title="text.caption">
                                                <img :src="text.image" class="img-thumbnail" />
                                            </a>
                                        </div>
                                        <!--End Image Section-->
                                        <!--Button Section-->
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div class="form-group mt-15">
                                                <p>Uploaded By : {{text.created_by}} (<a class="internal-link" target="_blank" :href="'mailto:' + text.created_by_email">{{text.created_by_email}}</a>)</p>
                                            </div>
                                            <div class="form-group">
                                                <p>Image Caption : {{text.caption}}</p>
                                            </div>
                                            <!--<div class="form-group">
                                                <p>Image Source : {{text.media_source}}</p>
                                            </div>-->
                                            <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <label for="categories"><!--{{index+1}} {{text.id}} -->Category<span class="text-danger">*</span></label>
                                                    <v-select v-model="categoryId[text.id]"
                                                              @change="changedValue"
                                                              @input="changedCategoryFor(text.id)"
                                                              name="categoryId"
                                                              :id="'categoryId_'+ index"
                                                              label="text"
                                                              :filterable="false"
                                                              :options="categoryArr"
                                                              @search="onSearchCategory"
                                                              placeholder="Select Category">
                                                              <template slot="no-options">
                                                            Search Category...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <font class="text-danger" :id="'categoryIdErrors_'+text.id"></font>
                                                </div>
                                            </div>
                                            <div class="clearfix"></div>
                                            <br/>
                                            <div class="row clearfix" >
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div class="alert" :id="'alertError_' + text.id">
                                                         <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                         <strong :id="'errorMsg_' + text.id" class="error"></strong>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <!--<input id="addMedia" type="button" value="Save" class="btn btn-primary" v-on:click.prevent="updateMedia(text.id)"></input>-->
                                                    <button id="addMedia" class="btn btn-primary" v-on:click.prevent="updateMedia(text.id,1)">Approve</button>
                                                    <button id="removeAll" class="btn btn-danger" v-on:click.prevent="deleteDayforceDocSection(text.id)">Reject</button>
                                                </div>
                                            </div>
                                        </div>
                                        <!--End Button Section-->
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <!--<button class="btn btn-danger deleteMedia policyForms"  v-on:click.prevent="deleteDayforceDocSection(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>-->
                            </div>
                        </template>
                    </div>
                </form>

            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    import vSelect from 'vue-select';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                categoryArr: [],
                categoryId: [],
                imagesForApproval: [],
                // imagePosition: [],
            }
        },
        computed: {

        },
        watch: {
            /*categoryId: function (categoryId) {
             console.log(JSON.stringify(categoryId));
             }*/
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.showLoader();
            self.MenuClose();
            self.getImages();
            self.loadCategoryFirst();
        },

        methods: {
            changedValue: function (value) {
                //console.log(value);
            },
            updateMedia: function (id, status) {
                $('#categoryIdErrors_' + id).html("");
                if (!self.categoryId[id]) {
                    console.log('error');
                    $('#categoryIdErrors_' + id).html("Category is Required");
                } else {
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You can\'t revert your action',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes Update it!',
                        cancelButtonText: "No, Don't Update!",
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            var fields = {
                                imageId: id,
                                categoryId: self.categoryId[id].value,
                                status: status,
                            };
                            var config = {
                                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                            };
                            HTTP.post("approveimage", fields, config)
                                    .then(function (response) {
                                        self.getImages();
                                    })
                                    .catch(function (err) {
                                        if (err.response.status == 0) {
                                            self.error = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                                //EventBus.$emit("logged-in", true, "", "");
                                            }
                                        }
                                    });
                            self.$swal('Updated', 'You successfully updated the record.', 'success')
                        } else {
                            self.$swal('Cancelled', 'Your record still intact', 'info')
                        }
                    });
                }
            },
            changedCategoryFor: function (id) {
                //self.categoryIdErrors[id] = '';
                $('#categoryIdErrors_' + id).html("");
            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadCategory(loading, search, this);
                }
            },
            loadCategoryFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': 'gallery',
                    }
                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadCategory(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': 'gallery',
                        'search': search,
                    }

                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            deleteDayforceDocSection: function (id) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        delete: id,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Reject it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletemedia", config)
                                .then(function (response) {
                                    self.getImages();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Rejected', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },
            getImages() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    inactive: 0,
                };
                self.showLoader();
                HTTP.post("getmedia", fields, config)
                        .then(function (response) {
                            self.imagesForApproval = response.data.content;
                            self.$nextTick(function () {
                                $.each(response.data.content, function (i) {
                                    console.log(response.data.content[i].category_id);
                                    if (response.data.content[i].category_id != null) {
                                        self.categoryId[response.data.content[i].id] = {
                                            value: response.data.content[i].category_id,
                                            text: response.data.content[i].category_name
                                        };
                                    }
                                    $('#alertError_' + response.data.content[i].id).hide();
                                });
                                $(".custom-checkbox").removeClass("custom-control");
                                jQuery("a[rel^='prettyPhoto']").prettyPhoto();
                            });
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/gallery/ImageListForApproval.vue